import {
  WORK_RIGHTS_UK_FIELDS,
  WORK_RIGHTS_UK_VALUES,
} from '@/core/field-names';
import { isEmptyObject } from '@/lib/is-empty-object';

/**
 * Filtering fields that will only contribute to work rights
 * document completion for UK region.
 * @param fieldValueMap {Object}
 * @param fieldValueMap.value {Any}
 * @param fieldValueMap.required {Boolean}
 * @param fieldValueMap.errorList {String[]}
 * @returns {String[]}
 */
export function filterWorkRightsToBeIncluded(fieldValueMap) {
  return filterWorkRightsUK(fieldValueMap);
}

/**
 * UK work rights completion logic (existing logic)
 * @param fieldValueMap {Object}
 * @returns {String[]}
 */
function filterWorkRightsUK(fieldValueMap) {
  const isBritishIrishResidence =
    fieldValueMap[WORK_RIGHTS_UK_FIELDS.RESIDENCY]?.value ===
    WORK_RIGHTS_UK_VALUES.BRITISH_IRISH;
  const isOtherCountryResidence =
    fieldValueMap[WORK_RIGHTS_UK_FIELDS.RESIDENCY]?.value ===
    WORK_RIGHTS_UK_VALUES.OTHER_RESIDENCE;
  const hasSelectedResidence =
    isBritishIrishResidence || isOtherCountryResidence;

  const hasBirthCertificate = !isEmptyObject(
    fieldValueMap[WORK_RIGHTS_UK_FIELDS.BIRTH_CERTIFICATE]?.value ?? {}
  );
  const hasPassport = !isEmptyObject(
    fieldValueMap[WORK_RIGHTS_UK_FIELDS.PASSPORT]?.value ?? {}
  );
  const hasAtLeastOneUKDocument = hasPassport || hasBirthCertificate;
  const hasBothUKDocument = hasPassport && hasBirthCertificate;

  // share code is required when "Other" residence is selected

  let shouldIncludePassport =
    isOtherCountryResidence ||
    (isBritishIrishResidence &&
      hasAtLeastOneUKDocument &&
      !hasBirthCertificate);
  let shouldIncludeBirthCertificate =
    isBritishIrishResidence && hasAtLeastOneUKDocument && !hasPassport;

  if (hasBothUKDocument) {
    shouldIncludePassport = true;
    shouldIncludeBirthCertificate = true;
  }
  if (!hasAtLeastOneUKDocument) {
    shouldIncludePassport = hasSelectedResidence;
    shouldIncludeBirthCertificate = hasSelectedResidence;
  }

  const workRightsRule = {
    [WORK_RIGHTS_UK_FIELDS.RESIDENCY]:
      fieldValueMap[WORK_RIGHTS_UK_FIELDS.RESIDENCY]?.required || false,
    [WORK_RIGHTS_UK_FIELDS.SHARE_CODE]: isOtherCountryResidence,
    [WORK_RIGHTS_UK_FIELDS.PASSPORT]: shouldIncludePassport,
    [WORK_RIGHTS_UK_FIELDS.BIRTH_CERTIFICATE]: shouldIncludeBirthCertificate,
  };

  return Object.keys(workRightsRule).filter((key) => {
    return workRightsRule[key];
  });
}
